import {
  domainBaseURLOption,
  fileDeleteApi,
  fileDownloadApi,
  fileResultApi,
  fileTemplateApi,
  fileUploadApi,
  fileUserApi,
} from "../../core/http/httpClient";
import { makeAsyncApiCall } from "../common";
import { takeEveryFsa } from "../operations";
import { fileActions } from "./actions";

export function* fileSaga() {
  yield takeEveryFsa(
    fileActions.getFileUploadTemplates.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        fileActions.getFileUploadTemplates,
        fileTemplateApi,
        domainBaseURLOption(),
      );
    },
  );

  yield takeEveryFsa(
    fileActions.getFileUploadUsers.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        fileActions.getFileUploadUsers,
        fileUserApi,
        domainBaseURLOption(),
      );
    },
  );

  yield takeEveryFsa(
    fileActions.getFileUploadResults.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        fileActions.getFileUploadResults,
        fileResultApi,
        domainBaseURLOption(),
      );
    },
  );

  yield takeEveryFsa(fileActions.uploadFile.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      fileActions.uploadFile,
      fileUploadApi,
      domainBaseURLOption(),
    );
  });

  yield takeEveryFsa(
    fileActions.downloadFileUploadResult.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        fileActions.downloadFileUploadResult,
        fileDownloadApi,
        domainBaseURLOption(),
      );
    },
  );

  yield takeEveryFsa(
    fileActions.deleteFileUploadResults.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        fileActions.deleteFileUploadResults,
        fileDeleteApi,
        domainBaseURLOption(),
      );
    },
  );
}
